<template>
  <div class="w-full h-full justify-center text-center">
    <div class="pt-10">
      <div class="mb-3">
        <LayupIcon class="my-3" />
        <h3 class="text-lg font-semibold text-black">Forgot Your Password?</h3>
        <p class="text-sm text-black">Enter your mobile number and we will help you reset it.</p>
        <p v-if="errorMessage" class="text-red-700">{{ errorMessage }}</p>
      </div>

      <div v-if="isLoading">
        <LayupSpinner />
      </div>
      <form class="m-0 p-0" v-else>
        <MobileNumberInput :label="'Mobile number'" v-model="cellNumber" class="text-left" />
        <div class="my-4">
          <TurnstileWidget data-testid="captcha-widget" @success="handleSuccess" />
        </div>
        <LayupButton
          type="submit"
          :disabled="isLoading || !turnstileToken"
          :isLoading="isLoading"
          :label="'Submit'"
          @click="onSubmit()"
        />

        <div class="text-center mt-2.5">
          <p class="text-gray-700 text-sm">
            Remember your password?
            <RouterLink class="btn text-cyan-700 p-0 text-sm" :to="{ name: 'WidgetSignIn' }">Sign In</RouterLink>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import LayupButton from '@/components/common/LayupButton.vue';
import LayupSpinner from '@/components/common/LayupSpinner.vue';
import TurnstileWidget from '@/components/common/TurnstileWidget.vue';
import LayupIcon from '@/components/icons/LayupIcon.vue';
import { BASE_URL } from '@/config';
import { NetworkError } from '@/errors';
import { forgotPassword } from '@/services/auth';
import { useGeneralStore } from '@/stores/general';
import { useUserStore } from '@/stores/users';
import { addMetric, createException, createWarning } from '@/utils/monitoring.utils';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import MobileNumberInput from '../../common/MobileNumberInput.vue';

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const generalStore = useGeneralStore();

const cellNumber = ref('');
const errorMessage = ref('');
const isLoading = ref(false);
const id = route?.params?.id;
const turnstileToken = ref('');
const onSubmit = async () => {
  try {
    isLoading.value = true;
    await forgotPassword(`${BASE_URL} shopper/payment-plan/${id}`, cellNumber.value, 'MOBILE', turnstileToken.value);
    generalStore.passwordReset = true;
    addMetric('forgot_password', { status: 'success', channel: 'widget' });
    userStore.user.cellNumber = cellNumber.value;
    await router.push({ name: 'OtpVerification' });
  } catch (error: any) {
    if (error instanceof NetworkError) {
      createWarning(error);
      addMetric('forgot_password', { status: 'network_error', channel: 'widget' });
      errorMessage.value = 'Network Error. Please try again.';
    } else {
      createException(error);
      addMetric('forgot_password', { status: 'error', channel: 'widget' });
      if (error?.response?.data) {
        errorMessage.value = error.response.data;
      } else {
        errorMessage.value = 'An unexpected error occurred. Please try again.';
      }
    }
  } finally {
    isLoading.value = false;
  }
};
function handleSuccess(token: string) {
  turnstileToken.value = token;
}
</script>
